import { useEditorRef } from '@udecode/plate-core';
import { insertImage } from '@udecode/plate-image';
import { ToolbarButton, ToolbarButtonProps } from '@udecode/plate-ui-toolbar';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { AuthContext } from 'libs/shared-firebase/src';
import resizeImage from 'libs/shared-firebase/src/lib/fileResizer';
import * as React from 'react';
import { useContext } from 'react';
import { safeNanoid } from '../../../utils/safeNanoid';
import { NoteIdContext } from '../SlateEditorWrapper';

export interface ToolbarImageProps extends ToolbarButtonProps {
  /**
   * Default onMouseDown is getting the image url by calling this promise before inserting the image.
   */
  getImageUrl?: () => Promise<string>;
}

export const CustomToolbarImage = ({
  getImageUrl,
  ...props
}: ToolbarImageProps) => {
  // assumed to be parent editor
  const editor = useEditorRef();
  const auth = React.useContext(AuthContext);

  const noteId = useContext(NoteIdContext);
  return (
    <>
      <ToolbarButton
        type="file"
        onMouseDown={async (event) => {
          event.preventDefault();
          const fileUploader = document.getElementById('fileUploader');
          fileUploader?.click();
          // let url;
          // if (getImageUrl) {
          //   url = await getImageUrl();
          // } else {
          //   //   url = window.prompt('Enter the URL of the image:');
          // }
          // if (!url) return;

          // insertImage(editor, url);
        }}
        {...props}
      />
      <input
        type="file"
        id="fileUploader"
        hidden
        onChange={async (evt) => {
          if (auth?.loggedInUser?.uid) {
            const uploadInfo = await upload(
              evt.target.files![0],
              auth.loggedInUser.uid,
              noteId
            );
            if (uploadInfo) {
              insertImage(editor, uploadInfo.url);
            }
          }
        }}
      />
    </>
  );
};

const upload = async (file: any, author: string, noteId: string) => {
  let fileExt = file.name.split('.').pop();
  let processedFile: File = file;

  // everything except gifs get processed into jpegs and resized
  // absolute 500kb limit after resizing, this will catch the really big GIFs
  // TODO: in the future, can allow premium users larger images
  if (fileExt !== 'gif') {
    processedFile = (await resizeImage({
      maxSize: 800,
      file: file,
    })) as File;
    fileExt = 'png';
  }

  const imageId = safeNanoid();
  const newImageRef = ref(
    getStorage(),
    `images/${author}/${noteId}/${imageId}.${fileExt}`
  );
  try {
    const result = await uploadBytes(newImageRef, processedFile);
    // newImageRef.set(processedFile);
    //  await newImageRef.put(processedFile);
  } catch (e) {
    window.alert(
      'Upload unsuccessful. Make sure the image is under the 500KB limit.'
    );
    return;
  }

  const url = await getDownloadURL(newImageRef);
  return {
    url,
    imageId,
  };
};
